export function initThrottleByDays({
  lastUpdateDateStorage = initLastUpdateDateStorage(),
  currentDate = new Date(),
  daysInterval,
}: {
  lastUpdateDateStorage?: ReturnType<typeof initLastUpdateDateStorage>;
  currentDate?: Date;
  daysInterval: number;
}) {
  return async (cb: () => Promise<void> | void) => {
    if (shouldUpdate()) {
      await cb();
      lastUpdateDateStorage.updateDate(currentDate);
    }

    function shouldUpdate() {
      const lastUpdate = lastUpdateDateStorage.getDate();
      if (!lastUpdate) return true;

      const diffTime = currentDate.getTime() - lastUpdate.getTime();
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      return diffDays >= daysInterval;
    }
  };
}

export function initLastUpdateDateStorage() {
  const name = 'lastAccountsUpdate';

  return {
    updateDate,
    getDate,
  };

  function updateDate(date: Date = new Date()) {
    localStorage.setItem(name, date.toISOString());
  }

  function getDate(): Date | null {
    const value = localStorage.getItem(name);
    return value ? new Date(value) : null;
  }
}

export function initLastUpdateDateStorageInMemory() {
  let lastUpdateDate: Date | null = null;

  return {
    updateDate,
    getDate,
  };

  function updateDate(date: Date = new Date()) {
    lastUpdateDate = date;
  }

  function getDate(): Date | null {
    return lastUpdateDate;
  }
}
